import { useState, useEffect } from "react";
import Competitor from "components/presentation/Competitor";
import Noc from "components/presentation/Noc";
import { useSelector } from 'react-redux';

import { usePrevious } from "../brackets/common";
import ScoresLiveCard from "components/common/ScoresLiveCard";

import Status from "components/presentation/Status";
import SportCode from "components/common/SportCode";
import Sprites from "styles/images/SpriteIcons.svg";
import NotAvailable from "components/common/NotAvailable";
import Label from "components/general/Label";
import SvgMirs from "components/presentation/SvgMirs";



//comment
export function Score(competitor) {
    const irm = competitor.showIRM && <div className='score-cards'>{competitor?.cp_irm}</div>
    const winner = competitor?.resultWLT === 'W' && <div className='score-winner'> <SvgMirs className='mirsIcon score-winner' role="img" title='HeaderWinner' code='circle-check' /></div>
    const [isLoading, setLoading] = useState(false);
    const result = competitor?.resultData; //competitor.cp_result );
    const prevResult = usePrevious({ result });
    const data = getCurrentAthleteData(competitor)

    //console.log('COMPONENT PREV-USE: ' + prevResult)
    function loadingTime() {
        return new Promise((resolve) => setTimeout(resolve, 4000));
    }
    useEffect(() => {
        if (isLoading) {
            loadingTime().then(() => {
                setLoading(false);
            });
        }
    }, [isLoading]);


    useEffect(() => {
        if (prevResult && (prevResult !== result)) {
            //console.log('COMPONENT old: ' + prevResult)
            //console.log('COMPONENT new: ' + result)
            setLoading(true)
        }

    }, [result])


    return (<>
        {data?.result && (<div className='score-result-container  d-flex flex-row justify-content-end'>
            <div className={`score-result text-end fw-bold ${isLoading ? 'score-result-update' : ''}`}>{data?.result}</div>
        </div>)}
        <div className='score-result-container  d-flex flex-row justify-content-end'>
            {winner} <div className={`score-result text-end fw-bold ${isLoading ? 'score-result-update' : ''}`}>{result}</div>
            {irm}
        </div>

    </>
    )
}
export function AthleteComponent(competitor) {
    const data = getCurrentAthleteData(competitor)
    return (
        data?.athlete &&
        (<div className='score-competitor-container  d-flex flex-row justify-content-start'>
            <div className='score-noc'>
            </div>
            <div className='score-name'> <Competitor {...data?.athlete} hideNoc={true} hidePicture={true} noLink={true} /> </div>
        </div>)
    )
}

export function AthleteScore(competitor) {
    const data = getCurrentAthleteData(competitor)
    if (data?.result !== undefined) {
        return (<div className='score-result-container  d-flex flex-row justify-content-end'><div className='score-result text-end fw-bold'>{data.result}</div></div>)
    }
    return ''
}

const getCurrentAthleteData = (competitor) => {
    if (competitor === undefined || competitor?.period === undefined) {
        return undefined
    }
    let period = competitor.period.substring(competitor.period.length - 1)
    let temp = competitor?.teamAthletes?.find(ath => ath?.extResults?.find(ext => ext?.er_code === 'BOUT' && ext?.er_pos === period))

    if (temp === undefined) {
        return undefined;
    }

    let data = {
        athlete: temp?.athlete,
        result: temp?.extResults?.find(ext => ext?.er_code === 'BOUT' && ext?.er_pos === period)?.extensions?.find(e => e?.ere_code === "SCORE")?.ere_value
    }

    return data
}




export function Footer({ data }) {
    const period = data?.result?.extendedInfos?.find(ei => ei?.ei_code === 'PERIOD')?.ei_value;
    let out = <Status typeToPrint={'schedule'} scheduleStatus={data?.status?.code} resultStatus={data?.result?.status?.code} />
    if (period && data?.result?.status?.code === 'LIVE') {
        out = <span className="fw-bold"><SportCode discipline='FEN' entity='@Period' code={period} /></span>
    }

    return (
        <div className='scores-today-status'>
            {out}
        </div>
    )
}


export function CompetitorBlock(props) {
    let bolding = props?.cp_wlt === 'W' ? ' fw-bold' : '';
    if (props?.boldWinner === false) {
        bolding = '';
    }

    const currentAthlete = props?.itemType === 'T' ? getAthlete(props) : undefined
    const resultAthlete = currentAthlete ? getResultAthlete(currentAthlete) : undefined;
    return (
        <div className={'score-competitor-container  d-flex flex-row justify-content-start w-100' + bolding}>
            <div className='score-noc'>
                <Noc className='me-1' {...props?.participant?.organisation} />
            </div>
            <div className='score-name w-60'>
                <div className='score-name'><Competitor  {...props?.participant} hideNoc={true} hidePicture={true} noLink={true} /> </div>
                {currentAthlete &&
                    <div className="d-flex flex-row justify-content-between">
                        <div className='score-name w-90'><Competitor  {...currentAthlete?.athlete} hideNoc={true} hidePicture={true} noLink={true} /> </div>
                        <div className='score-name w-10'>{resultAthlete}</div>
                    </div>
                }
            </div>
        </div>
    )
}

const getAthlete = (props) => {
    // ordenamos los period de mayor a menor
    const reverseSortedPeriods = props?.extendedInfos?.filter(ei => ei?.ei_code === 'COMP')?.sort((a, b) => b?.ei_pos - a?.ei_pos);
    // obtenemos el period mayor
    const highestPeriod = Array.isArray(reverseSortedPeriods) && reverseSortedPeriods?.length > 0 ? reverseSortedPeriods[0]?.ei_pos : undefined;
    // obtenemos el current period
    let relay = props?.extendedInfos?.find(ei => ei?.ei_code === 'PERIOD')?.ei_value;
    // si el current period es OT lo cambiamos por el periodo mas alto
    relay = relay === 'OT' && highestPeriod ? highestPeriod : relay?.slice(1)
    // obtenemos los dos atletas que disputan en el current period
    const currentPeriodAthArray = props?.extendedInfos?.find(ei => ei?.ei_code === 'COMP' && ei?.ei_pos === relay)?.extensions?.map(e => e?.eie_value);
    // buscamos en la lista de athletas del team, el current athlete 
    const currentAthlete = props?.teamAthletes?.find(ath => currentPeriodAthArray?.includes(ath?.athlete?.code));
    // como ya sé el current period, saco el resultado de ese period que está en los extendedResults
    const currentResult = currentAthlete?.extResults?.find(er => er?.er_code === 'BOUT' && er?.er_pos === relay);
    // lo añado al currentAthlete
    currentAthlete.currentResult = currentResult;

    return currentAthlete;

}

const getResultAthlete = (props) => {
    const out = props?.currentResult?.extensions?.find(e => e?.ere_code === 'SCORE')?.ere_value
    return out;
}

function passed5Minutes({ last, timeZone }) {
    if (!last) return true;
    const now = getNowTime({ timeZone: timeZone })
    const nowDate = new Date(`2000-01-01T${now}`);
    const lastDate = new Date(`2000-01-01T${last}`);

    //console.log(last, now)

    // Time difference in milliseconds
    const timeDiffMiliseconds = (nowDate - lastDate);

    // Time difference in minutes
    const timeDiffMinutes = timeDiffMiliseconds / (1000 * 60);

    //console.log(timeDiffMinutes)

    return timeDiffMinutes > 5;
}


export function CardsLayout({ results }) {

    const timeZone = useSelector((state) => state.appGlobal.timezone)
    const lastTime = getLastTime({ results: results })
    const hasPassed5Minutes = passed5Minutes({ last: lastTime, timeZone: timeZone })

    const blue = preparePiste({ results: results, piste: 'FEB' })
    const yellow = preparePiste({ results: results, piste: 'FEY' })
    const green = preparePiste({ results: results, piste: 'FEG' })
    const red = preparePiste({ results: results, piste: 'FER' })

    if (hasPassed5Minutes) return <NotAvailable label={'LabelNoDataDailyComponent'} />
    if (!blue && !yellow && !green && !red) return <NotAvailable label={'LabelNoDataDailyComponent'} />

    return (
        <>
            {
                [blue, yellow, green, red].map((item, index) => <Piste data={item} key={index} />)
            }
        </>
    )
}

const bc = <SvgMirs className='mirsIcon' code='card' />
const yc = <SvgMirs className='mirsIcon' code='yellow-card' />
const gc = <SvgMirs className='mirsIcon' code='green-card' />
const rc = <SvgMirs className='mirsIcon' code='red-card' />

const PisteColor = ({ data }) => {
    if (!data) return <></>
    return (
        <>
            {data === 'FEB' && bc}
            {data === 'FEY' && yc}
            {data === 'FEG' && gc}
            {data === 'FER' && rc}
        </>
    )
}

const Piste = ({ data }) => {
    if (!data) return <></>
    return (
        <>
            <div className="mirs-live-bouts m-auto">
                <div className="d-flex justify-content-between"><h2>{data?.location?.shortDescription} </h2><PisteColor data={data?.location?.code} /></div>
                <ScoresLiveCard data={data} />
            </div>
        </>
    )
}

const getLastTime = ({ results }) => {

    if (!results || !results?.at(-1) || !results?.at(-1)?.endDate) return undefined;

    const lastResult = results.at(-1)
    const lastDate = new Date(lastResult.endDate);

    // Extract the hours, minutes, and seconds
    const hours = lastDate.getHours() + 1;
    const minutes = lastDate.getMinutes();
    const seconds = lastDate.getSeconds().toString().padStart(2, '0');;
    const lastTime = hours + ':' + minutes + ':' + seconds
    return lastTime;
}

const getNowTime = ({ timeZone }) => {

    // Create a new Date object with the specified time zone
    const now = new Date();
    const options = { timeZone, hour: "numeric", minute: "numeric", second: "numeric" };

    // Format the date using Intl.DateTimeFormat
    const nowTime = new Intl.DateTimeFormat("en-GB", options).format(now);
    return nowTime;
}

const preparePiste = ({ results, piste }) => {
    const live = findFirstPiste({ results: results, piste: piste, status: 'LIVE' })
    const gettingReady = findFirstPiste({ results: results, piste: piste, status: 'GETTING_READY' })
    const finished = findLastPiste({ results: results, piste: piste, status: 'OFFICIAL' })
    const startList = findFirstPiste({ results: results, piste: piste, status: 'START_LIST' })

    return live || gettingReady || finished || startList
}

const findFirstPiste = ({ results, piste, status }) => {
    return results?.find(res => res?.location?.code === piste && res?.result?.status?.code === status)
}

const findLastPiste = ({ results, piste, status }) => {
    return results?.filter(res => res?.location?.code === piste && res?.result?.status?.code === status)?.at(-1)
}
